import { render, staticRenderFns } from "./RaceEditMenuOld.vue?vue&type=template&id=53d9a042&"
import script from "./RaceEditMenuOld.vue?vue&type=script&lang=js&"
export * from "./RaceEditMenuOld.vue?vue&type=script&lang=js&"
import style0 from "./RaceEditMenuOld.vue?vue&type=style&index=0&id=53d9a042&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports